export default function(array, length) {
    const limitCount = parseInt(length, 10);
    if (limitCount <= 0) {
        return array;
    }
    return array.slice(0, limitCount);
};
